import type { EventMarker } from '../../lib/decode/eventMarkers';

type EventTimelineProps = {
  startMs: number | null;
  endMs: number | null;
  markers: EventMarker[];
  selectedEventId: string | null;
  onSelectEvent: (eventId: string) => void;
};

function formatMs(value: number) {
  return `${value.toFixed(0)} ms`;
}

export function EventTimeline({ startMs, endMs, markers, selectedEventId, onSelectEvent }: EventTimelineProps) {
  if (startMs === null || endMs === null || endMs <= startMs) {
    return <div className="event-timeline empty">Upload a capture to use the event timeline.</div>;
  }

  const duration = endMs - startMs;

  return (
    <div className="event-timeline" aria-label="Event marker timeline">
      <div className="event-timeline-bar">
        {markers.map((marker) => {
          const left = Math.max(0, Math.min(100, ((marker.timestampMs - startMs) / duration) * 100));
          return (
            <button
              aria-label={`Select ${marker.label}`}
              className={marker.id === selectedEventId ? 'event-marker-dot active' : 'event-marker-dot'}
              key={marker.id}
              onClick={() => onSelectEvent(marker.id)}
              style={{ left: `${left}%` }}
              title={`${marker.label} at ${formatMs(marker.timestampMs)}`}
              type="button"
            />
          );
        })}
      </div>
      <div className="event-timeline-scale">
        <span>{formatMs(startMs)}</span>
        <span>{formatMs(endMs)}</span>
      </div>
    </div>
  );
}
